import { DEFAULT_MODEL_SETTINGS } from '../constants'

export const initialModelSettingsState = {
  modelSettings: { ...DEFAULT_MODEL_SETTINGS },
}
